module.exports = __webpack_public_path__ + "static/img/til24.febb311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til24.png
// module id = sUhQ
// module chunks = 1